/* eslint-disable */

import * as wording from '../../../common/js/wording';
import * as util from '../../../common/js/util';
//import {Coverage} from './Coverage'
import { IFbbSubmissionInfo } from '../IFbbSubmissionInfo';
import { ASession } from '../../common/ASession';
import { IModelUtil } from '../../common/IModelUtil';
import * as log from '../../../common/js/appLogger';

export class Address extends ASession implements IFbbSubmissionInfo, IModelUtil {
	protected sessionKey: string = 'Address';

	protected addrId: string | null = null; // localityId
	protected buildingNameEn: string | null = null;
	protected buildingNameZh: string | null = null;

	protected flat: string | null = null;
	protected floor: string | null = null;

	protected districtEn: string | null = null;
	protected areaEn: string | null = null;

	protected x_co: string | null = null;
	protected y_co: string | null = null;
	protected addr: string | null = null; // addr (have eng + chi)
	// @ts-ignore
	protected rawSplitAddrJson: json | null = null;

	protected needToChkWetlandPark: boolean = true;

	//=================================================================================

	constructor() {
		super();
		this.setData(this.getDefaultData());
		this.setSplitAddrData(this.getDefaultSplitAddrData());
	}

	protected getDefaultSplitAddrData(): any {
		return {
			rawSplitAddrJson: {},
		};
	}

	protected getSplitAddress1(): string {
		// only allow English address to pass api
		let line1 = '';
		let cleanString = '';
		let addr1String = '';
		if (util.isEmptyJson(this.getSplitAddrData())) {
			line1 = this.getName(wording.ENGLISH);
			//addr1String = 'Unit ' + this.getFlat() + ', Floor ' + this.getFloor() + ', ' + line1 + '';
			addr1String = line1 + '';
			cleanString = addr1String;
		} else {
			line1 = this.rawSplitAddrJson?.line1 ?? '';
			//addr1String = 'Unit ' + this.getFlat() + ', Floor ' + this.getFloor() + ', ' + line1 + '';
			addr1String = line1 + '';
			cleanString = wording.removeAddressNotMatchPattern(wording.capitizeFirstLetter(addr1String));
		}

		return cleanString;
	}

	protected getSplitAddress2(): string {
		// only allow English address to pass api
		let line2 = '';
		let cleanString = '';
		if (util.isEmptyJson(this.getSplitAddrData())) {
		} else {
			line2 = this.rawSplitAddrJson?.line2 ?? '';
			cleanString = wording.removeAddressNotMatchPattern(wording.capitizeFirstLetter(line2));
		}

		return cleanString;
	}

	protected getSplitAddressDistrict(): string {
		// only allow English address to pass api
		let dist1 = '',
			dist2 = '';
		let cleanString = '';
		if (util.isEmptyJson(this.getSplitAddrData())) {
		} else {
			let districtValue = this.getDistrictMappingValue();
			dist1 = wording.removeAddressNotMatchPattern(
				wording.capitizeFirstLetter(this.rawSplitAddrJson?.district + '')
			);
			dist2 = wording.removeAddressNotMatchPattern(wording.capitizeFirstLetter(districtValue + ''));
			cleanString = dist1 + '|' + dist2;
		}
		return cleanString;
	}

	protected getDistrictMappingValue(): string {
		var districtValue = this.rawSplitAddrJson?.line4 ?? '';

		var shortTermKey = districtValue.trim();
		switch (shortTermKey) {
			case 'NT':
				districtValue = 'New Territories';
				break;
			case 'KLN':
				districtValue = 'Kowloon';
				break;
			case 'HK':
				districtValue = 'Hong Kong';
				break;
			default:
				districtValue = shortTermKey;
		}
		return districtValue;
	}

	protected getSplitAddrData(): any {
		//throw new Error("Method not implemented.")
		return this.rawSplitAddrJson ?? {};
	}
	// @ts-ignore
	protected setSplitAddrData(data: json) {
		this.rawSplitAddrJson = data;
	}

	protected getDefaultData(): any {
		return {
			addrId: null, // localityId   ?
			buildingNameEn: null, // full eng addr
			buildingNameZh: null, // full chi addr
			flat: null,
			floor: null,
			districtEn: null,
			areaEn: null,
			addr: null,
			x_co: null,
			y_co: null,
			rawSplitAddrJson: {},
		};
	}

	protected getData(): any {
		//throw new Error("Method not implemented.")
		return {
			addrId: this.addrId ?? null,
			flat: this.flat ?? null,
			floor: this.floor ?? null,
			buildingNameEn: this.buildingNameEn ?? null,
			buildingNameZh: this.buildingNameZh ?? null,

			districtEn: this.districtEn ?? null,
			areaEn: this.areaEn ?? null,

			x_co: this.x_co ?? null,
			y_co: this.y_co ?? null,
			addr: this.addr ?? null,
			rawSplitAddrJson: this.rawSplitAddrJson ?? {},
		};
	}
	protected setData(data: any) {
		this.addrId = data.addrId;
		this.buildingNameEn = data.buildingNameEn;
		this.buildingNameZh = data.buildingNameZh;
		this.flat = data.flat;
		this.floor = data.floor;

		this.districtEn = data.districtEn;
		this.areaEn = data.areaEn;

		this.x_co = data.x_co;
		this.y_co = data.y_co;
		this.addr = data.addr;
		this.rawSplitAddrJson = data.rawSplitAddrJson ?? {};

		//parseInt(null) returns NaN but +null returns 0

		//don't call save() here.
	}

	//=================================================================================

	setAddressId(id: string | null) {
		this.addrId = id;
	}

	getAddressId(): string | null {
		return (this.addrId ?? '') + '';
	}

	setAddressXCo(x_co: string | null) {
		this.x_co = x_co;
	}

	getAddressXCo(): string | null {
		return (this.x_co ?? '') + '';
	}

	setAddressYCo(y_co: string | null) {
		this.y_co = y_co;
	}

	getAddressYCo(): string | null {
		return (this.y_co ?? '') + '';
	}

	setAddressString(addr: string | null) {
		this.addr = addr;
	}

	getAddressString(): string | null {
		return (this.addr ?? '') + '';
	}

	// no used ++++
	setHkbnAddressId(id: string | null) {
		// @ts-ignore
		this.hkbnAddrId = id;
	}
	getHkbnAddressId(): string | null {
		// @ts-ignore
		return this.hkbnAddrId + '';
	}

	setHGC(id: string | null) {
		// @ts-ignore
		this.hgcAddrId = id;
	}
	getHGCAddressId(): string | null {
		// @ts-ignore
		return this.hgcAddrId + '';
	}

	setICableAddressId(id: string | null) {
		// @ts-ignore
		this.icableAddrId = id;
	}
	getICableAddressId(): string | null {
		// @ts-ignore
		return this.icableAddrId + '';
	}

	// no used ----

	setNameEn(name: string | null) {
		this.buildingNameEn = name;
	}

	setNameZh(name: string | null) {
		this.buildingNameZh = name;
	}

	getDistrictEn(): string | null {
		return this.districtEn + '';
	}

	setDistrictEn(dis: string | null) {
		this.districtEn = dis;
	}

	getAreaEn(): string | null {
		return this.areaEn + '';
	}

	setAreaEn(area: string | null) {
		this.areaEn = area;
	}

	getName(lang: string | null): string {
		var targetLang = lang ?? wording.getLang();
		if (targetLang == wording.ENGLISH) {
			return this.buildingNameEn + '';
		} else {
			return this.buildingNameZh + '';
		}
	}

	getFlat(): string | null {
		return this.flat + '';
	}

	setFloor(_floor: string | null) {
		this.floor = _floor;
	}

	setFlat(_flat: string | null) {
		this.flat = _flat;
	}

	getFloor(): string | null {
		return this.floor + '';
	}

	static getFloorDisplay(floor: string | null, lang: string): string | null {
		if ('ROOF' === floor?.toUpperCase()) {
			if (wording.ENGLISH === lang) {
				return 'Roof';
			} else {
				return '天台';
			}
		}
		return floor + '';
	}

	getAddressDisplay(lang: string | null): string | null {
		var targetLang = lang ?? wording.getLang();
		if (targetLang === wording.ENGLISH) {
			//return this.getFlatFloorDisplay(lang) + ', ' + this.buildingNameEn
			return this.buildingNameEn;
		} else {
			//return this.buildingNameZh + ' ' + this.getFlatFloorDisplay(lang)
			return this.buildingNameZh;
		}
	}

	static getFlatDisplay(flat: string | null): string | null {
		return flat + '';
	}

	//if lang is null, got from stored lang
	getFlatFloorDisplay(lang: string | null): string {
		var targetLang = lang ?? wording.getLang();
		// eslint-disable-next-line eqeqeq
		if (targetLang == wording.ENGLISH) {
			return (
				'Room ' +
				Address.getFlatDisplay(this.flat) +
				', Floor ' +
				Address.getFloorDisplay(this.floor, targetLang)
			);
		} else {
			return (
				'樓 層 ' +
				Address.getFloorDisplay(this.floor, targetLang) +
				' 單 位 ' +
				Address.getFlatDisplay(this.flat)
			);
		}
	}

	getBuildingNameDisplay(lang: string | null): string | null {
		var targetLang = lang ?? wording.getLang();
		// eslint-disable-next-line eqeqeq
		if (targetLang == wording.ENGLISH) {
			return this.buildingNameEn;
		} else {
			return this.buildingNameZh;
		}
	}

	getIsWetlandAddr(): boolean {
		if (this.needToChkWetlandPark) {
			return (this.rawSplitAddrJson ?? {}).estate == 'WETLAND SEASONS PARK PHASE 1' ?? false;
		} else {
			return false;
		}
	}

	//=================================================================================

	//interface IFbbSubmissionInfo
	getSubmitParam(): any {
		throw new Error('Method not implemented.');
	}

	//=================================================================================
	//interface IModelUtil

	//No direct API result for Address.
	parseApiResult(data: any): void {
		throw new Error('Not Applicable.');
	}

	convertToJson() {
		var json = this.getData();
		json.rawSplitAddrJson = this.getDefaultSplitAddrData();
		return json;
	}

	convertFromJson(json: any): void {
		this.setData(json);
		this.setSplitAddrData(json);
	}
}
